function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErpLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17479_232580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.816 26.248C123.244 16.6699 107.66 16.6673 98.078 26.2402C98.0592 26.259 98.0431 26.2798 98.0248 26.2991L81.0083 43.3177C79.4809 44.8452 79.4814 47.3217 81.0088 48.8486C81.7723 49.612 82.773 49.9938 83.7742 49.9938C84.775 49.9938 85.7762 49.612 86.5402 48.8481L103.617 31.7695C103.628 31.758 103.638 31.745 103.65 31.7335C110.185 25.2494 120.774 25.2635 127.285 31.7783C133.813 38.3052 133.815 48.9263 127.289 55.4547L103.348 79.3955C100.186 82.5578 95.9811 84.2995 91.5089 84.2995C87.0366 84.2995 82.8319 82.5583 79.6691 79.3955C78.1417 77.8681 75.6652 77.8681 74.1378 79.3955C72.6103 80.9229 72.6103 83.3995 74.1378 84.9264C78.7779 89.566 84.9465 92.1213 91.5084 92.1213C98.0702 92.1213 104.239 89.566 108.878 84.9264L132.82 60.9851C142.396 51.407 142.393 35.823 132.816 26.248Z",
    fill: "#CCD5D3",
    style: {
      fill: "#CCD5D3",
      fill: "color(display-p3 0.8000 0.8353 0.8275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1196 55.0675L7.17835 79.0083C-2.39296 88.5864 -2.39296 104.17 7.17939 113.749C11.9687 118.539 18.2593 120.933 24.551 120.933C30.838 120.932 37.1271 118.54 41.9149 113.756C41.9159 113.755 41.9175 113.754 41.919 113.752L58.9955 96.671C60.5224 95.143 60.5224 92.667 58.9945 91.1396C57.4665 89.6127 54.9911 89.6127 53.4631 91.1401L36.3866 108.221L36.3856 108.223C29.8566 114.747 19.2371 114.745 12.7113 108.218C6.18649 101.689 6.18649 91.0661 12.7102 84.5381L36.651 60.5979C43.1795 54.0689 53.8016 54.0684 60.33 60.5958C61.8574 62.1232 64.334 62.1232 65.8609 60.5953C67.3883 59.0678 67.3878 56.5913 65.8603 55.0644C56.2817 45.4879 40.6967 45.4889 31.1196 55.0675Z",
    fill: "#CCD5D3",
    style: {
      fill: "#CCD5D3",
      fill: "color(display-p3 0.8000 0.8353 0.8275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8785 27.7019C65.5022 29.2084 66.9587 30.1179 68.494 30.1179C68.9925 30.1179 69.4994 30.0219 69.9886 29.8196C71.9843 28.9936 72.9329 26.7058 72.1063 24.7101L67.6899 14.0411C66.8644 12.0454 64.5761 11.0973 62.5804 11.9233C60.5847 12.7494 59.6361 15.0371 60.4626 17.0328L64.8785 27.7019Z",
    fill: "#CCD5D3",
    style: {
      fill: "#CCD5D3",
      fill: "color(display-p3 0.8000 0.8353 0.8275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.243 29.8175C80.7327 30.0204 81.2396 30.1163 81.7387 30.1163C83.2729 30.1163 84.7294 29.2074 85.3536 27.7013L89.7742 17.0344C90.6007 15.0387 89.6537 12.7509 87.658 11.9239C85.6628 11.0973 83.3751 12.0438 82.5475 14.0401L78.1269 24.707C77.3003 26.7022 78.2478 28.9905 80.243 29.8175Z",
    fill: "#CCD5D3",
    style: {
      fill: "#CCD5D3",
      fill: "color(display-p3 0.8000 0.8353 0.8275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9533 34.7679L57.6182 39.1891C58.1078 39.3924 58.6152 39.4884 59.1143 39.4884C60.6485 39.4884 62.1045 38.5794 62.7287 37.0739C63.5558 35.0787 62.6093 32.7905 60.6136 31.9634L49.9487 27.5417C47.9535 26.7136 45.6652 27.6617 44.8382 29.6569C44.0111 31.6526 44.9581 33.9409 46.9533 34.7679Z",
    fill: "#CCD5D3",
    style: {
      fill: "#CCD5D3",
      fill: "color(display-p3 0.8000 0.8353 0.8275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1198 112.299C74.2932 110.304 72.006 109.355 70.0103 110.181C68.0146 111.007 67.066 113.295 67.892 115.291L72.3074 125.959C72.9311 127.466 74.3876 128.376 75.9229 128.376C76.4214 128.376 76.9278 128.28 77.4169 128.077C79.4126 127.251 80.3612 124.964 79.5352 122.968L75.1198 112.299Z",
    fill: "#CCD5D3",
    style: {
      fill: "#CCD5D3",
      fill: "color(display-p3 0.8000 0.8353 0.8275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7468 110.182C57.7505 109.355 55.4633 110.301 54.6357 112.297L50.2135 122.962C49.3859 124.957 50.3324 127.245 52.3282 128.073C52.8183 128.276 53.3258 128.372 53.8248 128.372C55.359 128.372 56.815 127.464 57.4392 125.958L61.8614 115.293C62.6885 113.297 61.742 111.01 59.7468 110.182Z",
    fill: "#CCD5D3",
    style: {
      fill: "#CCD5D3",
      fill: "color(display-p3 0.8000 0.8353 0.8275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0386 105.221L82.3706 100.799C80.3749 99.9717 78.0871 100.919 77.26 102.914C76.433 104.91 77.38 107.198 79.3752 108.025L90.0432 112.447C90.5328 112.651 91.0402 112.747 91.5393 112.747C93.0735 112.747 94.5295 111.838 95.1537 110.332C95.9808 108.336 95.0338 106.048 93.0386 105.221Z",
    fill: "#CCD5D3",
    style: {
      fill: "#CCD5D3",
      fill: "color(display-p3 0.8000 0.8353 0.8275)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17479_232580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpLink);
export default __webpack_public_path__ + "static/media/erpLink.a12b4913b0b50137a828de92befad36d.svg";
export { ForwardRef as ReactComponent };